function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import isEmpty from 'lodash/isEmpty';
import { PropertyType } from '@domain-group/fe-allhomes-library';
import { ga4 } from '@domain-group/fe-co-allhomes-analytics';
var getListingCardEventParams = _ref => {
  var _PropertyType$propert;
  var address = _ref.address,
    property = _ref.property,
    price = _ref.price;
  var addressText = "".concat(address.street, ", ").concat(address.division, " ").concat(address.state, " ").concat(address.postcode);
  var propertyTypeEnum = (property.types || [])[0];
  var propertyType = ((_PropertyType$propert = PropertyType[propertyTypeEnum]) === null || _PropertyType$propert === void 0 ? void 0 : _PropertyType$propert.label) || propertyTypeEnum;
  return {
    element_is_modal: false,
    element_list_position: 1,
    element_tab_name: '',
    element_target_anchor_link: false,
    element_target_category_primary: '',
    element_target_page_type: '',
    element_title: '',
    element_values_selected: '',
    property_loc_address: addressText,
    property_bathrooms: property.baths,
    property_bedrooms: property.beds,
    property_parking: property.cars,
    property_type: propertyType,
    listing_price: price
  };
};
export var listingCardClickEvent = _ref2 => {
  var address = _ref2.address,
    property = _ref2.property,
    agency = _ref2.agency,
    price = _ref2.price;
  var params = getListingCardEventParams({
    address,
    property,
    price
  });
  return ga4.ga4event('listing_select', _objectSpread(_objectSpread({}, params), {}, {
    element_list_name: 'search result cards',
    element_position: 'middle',
    element_text: params.property_loc_address,
    element_type: 'search result card',
    property_loc_suburb: address.division,
    property_loc_postcode: address.postcode,
    agency: agency.name
  }));
};
export var listingCardAgencyClickEvent = _ref3 => {
  var address = _ref3.address,
    property = _ref3.property,
    agency = _ref3.agency,
    price = _ref3.price;
  var getAgentsText = () => {
    var agents = agency.agents || [];
    if (isEmpty(agents)) {
      return agency.name;
    }
    var agentsText = agents[0].name;
    if (agents.length > 1) {
      agentsText = "".concat(agentsText, " & ").concat(agents[1].name);
    }
    return "".concat(agentsText, ", ").concat(agency.name);
  };
  return ga4.ga4event('cta_driver', _objectSpread(_objectSpread({}, getListingCardEventParams({
    address,
    property,
    price
  })), {}, {
    element_list_name: 'search result cards',
    element_position: 'middle',
    element_target_category_primary: 'Find an Agent',
    element_target_page_type: 'Agency Profile',
    element_text: getAgentsText(),
    element_title: 'Listing Agency',
    element_type: 'search result card',
    property_loc_suburb: address.division,
    property_loc_postcode: address.postcode,
    agency: agency.name
  }));
};
export var listingCardAddToWatchlistEvent = _ref4 => {
  var address = _ref4.address,
    property = _ref4.property,
    price = _ref4.price,
    position = _ref4.position,
    listingCategory = _ref4.listingCategory;
  var isMultipleCard = !!position;
  return ga4.ga4event('shortlist_add', _objectSpread(_objectSpread({}, getListingCardEventParams({
    address,
    property,
    price
  })), {}, {
    element_list_name: isMultipleCard ? 'map listing card' : '',
    element_list_position: position,
    element_position: 'map',
    element_target_category_primary: listingCategory,
    element_target_page_type: 'Listing',
    element_text: 'Shortlist',
    element_title: 'map listing card',
    element_type: 'svg star icon'
  }));
};
export var viewRealEstateAgentsInClickEvent = _ref5 => {
  var elementText = _ref5.elementText;
  return ga4.ga4event('cta_driver', {
    element_is_modal: false,
    element_list_name: 'Suburb profile',
    element_list_position: 2,
    element_position: 'bottom middle',
    element_tab_name: '',
    element_target_anchor_link: false,
    element_target_category_primary: 'Find an Agent',
    element_target_page_type: 'Search Page',
    element_text: elementText,
    element_title: '',
    element_type: 'text link',
    element_values_selected: ''
  });
};
export var surroundingSuburbsClickEvent = _ref6 => {
  var position = _ref6.position,
    listingCategory = _ref6.listingCategory,
    elementText = _ref6.elementText,
    elementTitle = _ref6.elementTitle;
  return ga4.ga4event('search', {
    element_is_modal: false,
    element_list_name: 'Suburbs nearby',
    element_list_position: position,
    element_position: 'bottom',
    element_tab_name: '',
    element_target_anchor_link: false,
    element_target_category_primary: listingCategory,
    element_target_page_type: 'Search Page',
    element_text: elementText,
    element_title: elementTitle,
    element_type: 'text link',
    element_values_selected: ''
  });
};